import { Injectable } from '@angular/core';

import { ApiService } from '@frontend/sports/common/api-utils';
import { InternalFeaturesConfig } from '@frontend/sports/common/client-config-data-access';
import { BaseCustomLogger } from '@frontend/sports/common/core/feature/logging';

import { EarlyPayoutPossibility } from '../models/early-payout';

@Injectable({
    providedIn: 'root',
})
export class EPSDetailedLogger extends BaseCustomLogger<EarlyPayoutPossibility> {
    constructor(
        api: ApiService,
        private internalConfig: InternalFeaturesConfig,
    ) {
        super(api, 'epslogger/logcheckresponse');
    }

    protected override isEnabled = (): boolean => this.internalConfig.isEPSDetailedLoggingEnabled;
}
